import { TypePolicy } from '@apollo/client';

export const audioFileTypePolicy: TypePolicy = {
  fields: {
    libraryAvailability: {
      merge( _existing, incoming ) {
        return incoming;
      },
    },
  },
};
